import { tanstackQueryService } from '@core/services/TanstackQuery.service';
import { WHO_AM_I_QUERY_KEY } from '@shared/constants/whoAmI.constant';
import { whoAmIService } from '@shared/services/WhoAmI.service';

class WhoAmIQuery {
  public getWhoAmI$ = (enabled: boolean) => {
    return tanstackQueryService.query({
      queryKey: [WHO_AM_I_QUERY_KEY],
      queryFn: () => whoAmIService.getWhoAmI(),
      enabled
    });
  };
}

const whoAmIQuery = new WhoAmIQuery();

export { whoAmIQuery };
